/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

export const deepEqual = (a, b) => {
    let val = true
    const keys = Object.keys(a)
    for (let key of keys) {
        if (a[key] !== b[key]) {
            val = false
            break
        }
    }
    return val
}

export const loop = func => {
    return window.requestAnimationFrame(func)
    //return setTimeout(() => { func(Date.now()) }, 1000/60)
}

export const endLoop = id => {
    window.cancelAnimationFrame(id)
    //clearTimeout(id)
}

export const scaleCanvas = (canvas) => {
    const size = canvas.getBoundingClientRect()
    const ctx = canvas.getContext('2d')
    const devicePixelRatio = window.devicePixelRatio || 1
    const backingStoreRatio = (
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio || 1
    )
    const ratio = devicePixelRatio / backingStoreRatio

    if (devicePixelRatio !== backingStoreRatio) {
        canvas.width = size.width * ratio
        canvas.height = size.height * ratio

        canvas.style.width = size.width + 'px'
        canvas.style.height = size.height + 'px'
    } else {
        canvas.width = size.width
        canvas.height = size.height
        canvas.style.width = ''
        canvas.style.height = ''
    } 
    console.log('scaleCanvas', size, ratio)
    //ctx.scale(ratio, ratio)

    return { scale: ratio, w: size.width*ratio, h: size.height*ratio }
}
